module.exports = __webpack_public_path__ + "static/media/30sec_single_bieb.d4fefda1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30sec_single_bieb.mp3
// module id = 215
// module chunks = 0